/**
 * Путь/URL иконки типа задачи из work.issue_type.icon (как dynamic_fields.avatar_url у проектов).
 */
export function resolveIssueTypeIconUrl(icon: string | null | undefined): string | null {
  if (typeof icon !== 'string' || !icon.trim()) return null;
  const s = icon.trim();
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('//')) return s;
  if (s.startsWith('/')) return s;
  return `/issue_type_icon/${s}`;
}

/** Базовое имя файла иконки без пути и `.svg` — для инлайн-глифов. */
export function issueTypeIconBasename(icon: string | null | undefined): string | null {
  if (typeof icon !== 'string' || !icon.trim()) return null;
  let s = icon.trim().toLowerCase();
  const parts = s.split(/[/\\]/);
  s = parts[parts.length - 1] ?? s;
  if (s.endsWith('.svg')) s = s.slice(0, -4);
  return s || null;
}

// Палитра типов задач: подобрана к общей приглушённой гамме (L≈42–60%, S≈30–50%),
// сохраняет смысловые оттенки оригинальных Jira-подобных цветов.
//   task     — индиго (= $accent-tasks)
//   subtask  — светлый индиго (= $accent-tasks-muted), отличается от task светлотой
//   story    — приглушённая олива/lime, между sage Projects и gold Knowledge
//   epic     — приглушённый magenta-violet, остаётся «выделяющимся»
//   bug/bag  — приглушённый кирпично-коралловый, сохранил тёплый красно-оранжевый
const ACCENT_FALLBACK_BY_KEY: Record<string, string> = {
  epic: '#8d4ea0',
  story: '#7a9b3d',
  bug: '#c25c4f',
  bag: '#c25c4f',
  task: '#5454a1',
  subtask: '#7878b6',
};

/**
 * Цвет кружка/бейджа и --it-accent: из БД или запасной палитры по slug / имени иконки.
 */
export function resolveIssueTypeAccent(
  color: string | null | undefined,
  slug?: string | null,
  icon?: string | null,
): string {
  const c = typeof color === 'string' ? color.trim() : '';
  if (c) return c;
  const sl = (slug ?? '').trim().toLowerCase();
  if (sl && ACCENT_FALLBACK_BY_KEY[sl]) return ACCENT_FALLBACK_BY_KEY[sl];
  const base = issueTypeIconBasename(icon);
  if (base && ACCENT_FALLBACK_BY_KEY[base]) return ACCENT_FALLBACK_BY_KEY[base];
  return ACCENT_FALLBACK_BY_KEY.task;
}

const INLINE_GLYPH_BASENAMES = new Set(['task', 'story', 'epic', 'subtask', 'bag']);

/** Локальные ассеты с инлайн-глифом (инверсия surface/accent); остальное — через <img>. */
export function issueTypeIconHasInlineGlyph(icon: string | null | undefined): boolean {
  const b = issueTypeIconBasename(icon);
  return b != null && INLINE_GLYPH_BASENAMES.has(b);
}
